

















































import {
  defineComponent,
  Ref,
} from '@vue/composition-api'
import { useVModel } from '@vueuse/core'

interface Aggregation {
  ids: string[]
  name: string
  type: string
  _destroy?: boolean
}

interface AggregationGroup {
  type: string
  aggregations: Aggregation[]
}

export default defineComponent({
  props: {
    aggregations: {
      type: Array as () => AggregationGroup[],
      required: true,
    },
  },
  setup(props, { emit }) {
    const selectedItems = useVModel(props, 'aggregations') as Ref<AggregationGroup[]>

    const isToDestroy = (aggregation: Aggregation) => {
      const flatAggregations = selectedItems.value?.map(item => item.aggregations).flat() || []

      return flatAggregations.find(item => item.ids === aggregation.ids && item.type === aggregation.type)?._destroy
    }

    const toggleSelection = (aggregation: Aggregation) => {
      emit('update:aggregations', aggregation)
    }

    return {
      selectedItems,
      isToDestroy,
      toggleSelection,
    }
  },
})
